(function ($, window) {
    $(function () {
        // --- Toggle mobile menu ---
        $('.js-toggle-mobile-menu').on('click', function (e) {
            $('html').toggleClass('h-menu-visible');
            e.preventDefault();
        });
    });
})(jQuery, window);